import { AxiosInstance } from "axios";
import { ApiRouteHelpers } from "../../../root/apiRoutes";
import { ServiceAccountInboxMessageDto } from "../dto/ServiceAccountInboxMessageDto";
import { ServiceAccountSetupDto } from "../dto/ServiceAccountSetupDto";
import { OrganizationPublicId } from "../Types";

/**
 * Dev-only backend endpoint (`ServiceAccountInboxDebugController`, `@Profile("dev")`) that fakes a
 * Postmark inbound delivery. Returns 404 outside dev environments.
 */
const DEBUG_MOCK_EMAIL_PATH = "/debug/ramsay/service-account-email";

export class ServiceAccountInboxController {
  constructor(private axios: AxiosInstance) {}

  public getMessages = async (
    organizationId: OrganizationPublicId,
  ): Promise<ServiceAccountInboxMessageDto[]> => {
    const url = ApiRouteHelpers.organization.ramsay.serviceAccountInbox(organizationId);
    const response = await this.axios.get<ServiceAccountInboxMessageDto[]>(url);
    return response.data;
  };

  /** Sends a mock email through the same ingest path as the Postmark webhook. Dev environments only. */
  public sendMockEmail = async (params: {
    to: string;
    from?: string;
    subject?: string;
    body: string;
  }): Promise<ServiceAccountInboxMessageDto> => {
    const response = await this.axios.get<ServiceAccountInboxMessageDto>(DEBUG_MOCK_EMAIL_PATH, {
      params,
    });
    return response.data;
  };

  public getServiceAccounts = async (
    organizationId: OrganizationPublicId,
  ): Promise<ServiceAccountSetupDto> => {
    const url = ApiRouteHelpers.organization.ramsay.serviceAccounts(organizationId);
    const response = await this.axios.get<ServiceAccountSetupDto>(url);
    return response.data;
  };
}
